  import React,{useState,useEffect,useRef,useMemo} from 'react'
  import {
    ArrowRight,
    Phone,
    Flame,
    Building2,
    GraduationCap,
    TrendingUp,
    X,
    User,
    Mail,
    Smartphone,
    Briefcase,
    Zap,
    Globe,
    MapPin,
    Star,
    Users,
    Calendar,
  } from "lucide-react"
  import axios from 'axios'
  import { useQuery } from '@tanstack/react-query'
import { ClipLoader } from 'react-spinners'
import { useLocation, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { activateEvent } from '../utils/api'
import { initializePayment } from '../utils/paymentUtils'
import { PaymentType } from '../utils/paymentTypes';
  function EventCard({ title, subtitle, tagline, features, hasSupport, icon: Icon=Calendar, index, stats, gradient = "from-[#fd3e3d] to-[#ff7b7b]", // ✅ DEFAULT
  primary = "#fd3e3d",logo,full }) {
    const [isModalOpen, setIsModalOpen] = useState(false)
     const [filteredEvents, setFilteredEvents] = useState({
    selectedDateEvents: [],
    upcomingEvents: [],
    hasDateFilter: false
  });
  const [activeTab, setActiveTab] = useState("All");
  const [filters, setFilters] = useState({
    name: "",
    location: "",
    startDate: "",
    mode: "",
  });
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const formRef = useRef(null);
  const [showModal, setShowModal] = useState(false);

  const [processing, setProcessing] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [paymentSessionId, setPaymentSessionId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [payLoading, setPayLoading] = useState(false)



  const completedSyncedRef = useRef(new Set());
    const [formData, setFormData] = useState({
      name: "",
      phone: "",
      email: "",
      startupName: "",
    })
    const [isSubmitting, setIsSubmitting] = useState(false)


   



  const [selectedEvent,setSelectedEvent]=useState(null)


   const handleRegisterClick = (event) => {
      console.log(event)
      const isPaid = event?.type?.[0]?.toLowerCase() === "paid";
      const isFree = event?.type?.[0]?.toLowerCase() === "free";
      const token = localStorage.getItem("Startuptoken");
  
      if (event.eventMode == "NonRegistered") {
        setSelectedEvent(event)
        setIsModalOpen(true)
        return
      }
  
      if ((isPaid || isFree) && !token) {
        toast.error("This event is only for Tactos Community Members please Login/register to continue");
        navigate("/login", { state: { from: location.pathname } });
  
        return;
      }
  
      setSelectedEvent(event)
      setIsModalOpen(true)
    }
 const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    founderId: "",
    startupName: "",
    industry: "",
    startupLocation: ""
  });
 const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    userType: "individual",
    founderId: "",
    startupName: "",
    industry: "",
    startupLocation: ""
  });


   const handleVerify = async () => {
      if (!form.founderId) {
        toast.error("Please enter a Founder ID to verify")
        return
      }
  
      try {
        setVerifyLoading(true)
  
        const resp = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/founder-kyc/${form.founderId}`
        )
        console.log("🔍 verify response:", resp.data)
  
        const { success, data } = resp.data
        if (!success) {
          throw new Error(resp.data.message || "Verification failed")
        }
  
        const { founderKyc, startup } = data
        if (!founderKyc?.founderId) {
          throw new Error("Founder not found")
        }
  
        setForm(f => ({
          ...f,
          founderId: founderKyc.founderId,
          name: founderKyc.founderName || f.name,
          email: founderKyc.email || f.email,
          phone: founderKyc.phoneNumber || f.phone,
          startupName: startup?.startupName || f.startupName,
          industry: startup?.industry || f.industry,
          startupLocation: startup?.location || founderKyc.address || f.startupLocation,
        }))
  
        setIsVerified(true)
        toast.success("Founder verified successfully!")
      } catch (err) {
        console.error("Verify error:", err)
        toast.error(
          err.response?.data?.message
          || err.message
          || "Verification failed"
        )
        setIsVerified(false)
      } finally {
        setVerifyLoading(false)
      }
    }
  
  
    const handleBackdropClick = (e) => {
      if (e.target === e.currentTarget) {
        setShowModal(false)
      }
    }
  
    const handlePaymentSuccess = async (paymentResult) => {
      console.log("Clicked")
      try {
        const token = localStorage.getItem('Startuptoken');
        const orderId = paymentResult.orderId;
        
  
        console.log('Payment succeeded; verifying with backend…', orderId);
        toast.loading('Verifying payment...', { id: 'payment-verification' });
  
        // Verify payment with backend
        const verifyRes = await fetch('/api/payment/verify', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ orderId })
        });
  
        if (!verifyRes.ok) {
          const errorData = await verifyRes.json();
          throw new Error(errorData.error || 'Payment verification failed');
        }
  
        const { verified } = await verifyRes.json();
        if (!verified) {
          throw new Error('Payment not verified');
        }
  
        // Complete the event registration
        await completeEventRegistration(paymentResult.transactionId);
  
        toast.success('Registration successful!', { id: 'payment-verification' });
      } catch (error) {
        console.error('Payment verification error:', error);
        toast.error(error.message || 'Payment verification failed', {
          id: 'payment-verification'
        });
      } finally {
        setProcessing(false);
        setShowPaymentModal(false);
        setPayLoading(false)
      }
    };
  
    const completeEventRegistration = async (transactionId = null) => {
  
      try {
        const token = localStorage.getItem('Startuptoken');
  
        // Restore registration data saved before payment
        const savedData = JSON.parse(sessionStorage.getItem("event_registration")) || {};
  
        // 🧩 Combine restored + current form safely
        const basePayload = {
          name: form?.name || savedData.name,
          email: form?.email || savedData.email,
          phone: form?.phone || savedData.phone,
          userType: form?.userType || savedData.userType || "individual",
          founderId: form?.founderId || savedData.founderId || null,
          startupName: form?.startupName || savedData.startupName || null,
          industry: form?.industry || savedData.industry || null,
          startupLocation: form?.startupLocation || savedData.startupLocation || null,
          eventId: selectedEvent?._id || savedData.eventId,
          eventName: selectedEvent?.name || savedData.eventName,
          eventType: selectedEvent?.type[0] || savedData.eventType,
          paymentStatus: transactionId ? "Paid" : "Unpaid",
          transactionId: transactionId || null,
        };
  
        // 🧠 Extract dynamic fields from event
        const eventFields = selectedEvent?.fields || savedData.fields || [];
        const dynamicFieldData = {};
  
        // Loop through dynamic fields and get user responses from `form`
        eventFields.forEach((field) => {
          const fieldKey = field.label; // using label as key
          dynamicFieldData[fieldKey] = form?.[fieldKey] || savedData[fieldKey] || "";
        });
  
        // Combine everything into final payload
        const payload = {
          ...basePayload,
          fields: eventFields.length > 0 ? eventFields.map(f => ({
            label: f.label,
            type: f.type,
            value: dynamicFieldData[f.label] || "",
            required: f.required || false
          })) : [],
        };
  
  
        // Include auth headers only if token exists
        const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  
        // 🔥 Send request
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/eventregister`,
          payload,
          config
        );
  
        // ✅ Check success
        if (res?.status === 201 && res?.data?.success) {
          await activateEvent(res.data.eventData.eventId, res.data.registrationId);
          toast.success("Registered successfully!");
          sessionStorage.removeItem("event_registration");
          setIsModalOpen(false);
        } else {
          throw new Error(res?.data?.message || "Failed to complete registration");
        }
  
        return res.data;
  
      } catch (error) {
        console.error("Registration error:", error);
        toast.error(error.response?.data?.message || "Registration failed");
        throw error;
      }
    };
  
  
  
    const resetForm = () => {
      setForm({
        name: "",
        email: "",
        phone: "",
        userType: form.userType,
        founderId: "",
        startupName: "",
        industry: "",
        startupLocation: ""
      });
      setIsVerified(false);
      setProcessing(false);
    };
  
    const validateField = (name, value) => {
      let error = "";
  
      switch (name) {
        case "name":
          if (!value.trim()) error = "Name is required";
          else if (value.length < 3) error = "Name must be at least 3 characters";
          else if (!/^[a-zA-Z\s]*$/.test(value)) error = "Name can only contain letters and spaces";
          break;
        case "email":
          if (!value.trim()) error = "Email is required";
          else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = "Invalid email format";
          break;
        case "phone":
          if (!value.trim()) error = "Phone number is required";
          else if (!/^[0-9]{10}$/.test(value)) error = "Phone must be 10 digits";
          break;
        case "founderId":
          if (form.userType === "founder" && !isVerified && value.trim()) {
            error = "Please verify your founder ID";
          }
          break;
        case "startupName":
          if (form.userType === "founder" && !value.trim()) error = "Startup name is required";
          break;
        case "industry":
          if (form.userType === "founder" && !value.trim()) error = "Industry is required";
          break;
        case "startupLocation":
          if (form.userType === "founder" && !value.trim()) error = "Location is required";
          break;
        default:
          break;
      }
  
      return error;
    };
  
    const validateForm = () => {
      const newErrors = {};
  
      // 1. Validate dynamic fields
      selectedEvent?.fields?.forEach((field) => {
        const key = field.label.toLowerCase().replace(/\s+/g, "_");
        if (field.required && (!form[key] || !form[key].trim())) {
          newErrors[key] = `${field.label} is required`;
        }
      });
  
      // 2. Validate extra fields for Paid events if not in dynamic fields
      if (selectedEvent.type[0].toLowerCase() === "paid") {
        const requiredFields = ["name", "email", "phone"];
        requiredFields.forEach((field) => {
          const existsInFields = selectedEvent.fields.some(
            (f) => f.label.toLowerCase() === field
          );
          if (!existsInFields && (!form[field] || !form[field].trim())) {
            newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
          }
        });
      }
  
      setErrors(newErrors);
  
      // Return true if no errors
      return Object.keys(newErrors).length === 0;
    };
  
    useEffect(() => {
      console.log(form)
    }, [form])
  
  
    const handleChange = (e) => {
      const { name, value } = e.target;
  
      if (name === "phone" && value && !/^[0-9]*$/.test(value)) {
        return;
      }
  
      if (name === "name" && value && !/^[a-zA-Z\s]*$/.test(value)) {
        return;
      }
  
      setForm(f => ({ ...f, [name]: value }));
  
      if (name in errors) {
        setErrors(prev => ({
          ...prev,
          [name]: validateField(name, value)
        }));
      }
  
      if (name === 'founderId' && isVerified) {
        setIsVerified(false);
      }
    };
  
  
  
    const handleSubmit = async (e) => {
      console.log("CLicked")
      e.preventDefault();
      console.log("selectedEvent", selectedEvent.type[0].toLowerCase())
      let token = localStorage.getItem('Startuptoken');
      const eventType = selectedEvent?.type?.[0]?.toLowerCase(); // "paid" or "free"
      const eventMode = selectedEvent?.eventMode[0];
      // if (selectedEvent?.type?.toLowerCase() === "paid" && !token) {
      //   toast.error("This event is only for Tactos Community Members please Login/register to continue");
      //   setProcessing(false);
      //   navigate("/login", { state: { from: location.pathname } });
      //   return;
      // }
  
      if (token === "DEMO_TOKEN") {
        token = null;
      }
  
  
      if (!validateForm()) {
        toast.error("Please fix the errors in the form");
        return;
      }
  
      if (eventMode === "Registered" && !token) {
  
        toast.error("This event is for registered users only. Please login.");
        setProcessing(false);
        navigate("/login", { state: { from: location.pathname } });
        return;
      }
  
  
  
  
  
      try {
        // Store registration data in session storage
        sessionStorage.setItem(
          `event_registration`,
          JSON.stringify({
            ...form,
            eventId: selectedEvent._id,
            eventName: selectedEvent.name,
            eventType: selectedEvent.type[0],
            eventMode: selectedEvent.eventMode[0]
          })
        );
  
        const isPaid = eventType === "paid"
  
        console.log("type", form.userType)
  
        if (isPaid) {
          const token = localStorage.getItem('Startuptoken');
          // if (!token) {
          //   toast.error("Please log in to continue");
          //   setProcessing(false);
          //   return;
          // }
  
          // Convert amount to number and validate
          if (isPaid) {
            const amount = parseFloat(selectedEvent.amount);
            if (isNaN(amount) || amount <= 0) {
              throw new Error("Invalid event price");
            }
            // Initialize payment
            const paymentResult = await initializePayment({
              type: PaymentType.EVENT,
              amount,
              token,
              returnUrl: `${window.location.origin}/payment-callback`,
            });
  
            toast.loading("Redirecting to payment gateway...", { id: "payment" });
          }
        } else {
          await completeEventRegistration();
          // toast.success("Registration successful!");
          setShowModal(false);
          resetForm();
        }
      } catch (error) {
        console.error('Submission error:', error);
        toast.error(error.message || 'Submission failed');
        setProcessing(false);
      } finally {
        setPayLoading(false)
      }
    };
    const handlePayButtonClick = () => {
      setPayLoading(true); // 🔥 start loader
      console.log("Pay");
  
      const isPaid = selectedEvent?.type?.[0]?.toLowerCase() === "paid";
      const eventType = selectedEvent?.eventMode?.[0]?.toLowerCase() === "registered";
      const token = localStorage.getItem("Startuptoken");
  
      if (isPaid && eventType && !token) {
        toast.error("Please log in to continue");
        setPayLoading(false);    // 🔥 stop loader
        setProcessing(false);
        setShowModal(false);
        navigate("/login", { state: { from: location.pathname } });
        return;
      }
  
      if (formRef.current) {
        formRef.current.requestSubmit(); // triggers handleSubmit
      }

    
  
      // Loader will stop inside handleSubmit after API finishes
    };

  const ICONS = [Zap, Flame, Calendar, Star, TrendingUp, Users, Globe];

const RandomIcon = ICONS[index % ICONS.length];


    return (
      <>
        <div className="group relative w-full min-h-[180px] md:max-h-[145px] overflow-hidden rounded-2xl sm:rounded-3xl bg-white border border-neutral-200 hover:border-[#fd3e3d]/30 transition-all duration-500 hover:shadow-xl hover:shadow-[#fd3e3d]/5">
          {/* Decorative gradient background element */}
          <div className="absolute top-0 right-0 w-48 sm:w-72 h-48 sm:h-72 bg-gradient-to-bl from-[#fd3e3d]/5 via-transparent to-transparent rounded-full -translate-y-1/2 translate-x-1/4 group-hover:from-[#fd3e3d]/10 transition-all duration-700" />

          {/* Left accent stripe */}
          <div className="absolute left-0 top-0 bottom-0 w-1 sm:w-1.5 bg-gradient-to-b from-[#fd3e3d] to-[#ff7b7b] rounded-l-2xl sm:rounded-l-3xl" />

          {/* Index number - smaller on mobile */}
          <div className="absolute top-2 sm:top-4 right-3 sm:right-6 text-5xl sm:text-7xl font-black text-neutral-100 group-hover:text-[#fd3e3d]/10 transition-colors duration-500 select-none">
            {String(index + 1).padStart(2, "0")}
          </div>

          <div className="relative h-full p-4 sm:p-6 md:p-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
            {/* Left section - Icon and content */}
            <div className="flex items-start gap-3 sm:gap-5 flex-1">
              {/* Icon - smaller on mobile */}
              <div className="relative shrink-0">
              <div
  className={`w-12 h-12 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-lg`}
>
  <RandomIcon className="w-6 h-6 text-white" />
</div>


                {/* Floating badge - smaller on mobile */}
                <div className="absolute -bottom-1 -right-1 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-black flex items-center justify-center shadow-md">
                  <Star className="w-2.5 h-2.5" style={{ color: primary, fill: primary }} />

                </div>
              </div>

              {/* Content - smaller text sizes */}
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-md md:text-md font-bold text-black mb-1 group-hover:text-[#fd3e3d] transition-colors duration-300 leading-tight">
                  {title}
                </h3>

                {subtitle && (
                  <p className="text-neutral-500 text-xs sm:text-sm mb-2 sm:mb-3 line-clamp-2 max-w-md">Host:{subtitle}</p>
                )}

                {tagline && (
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1 sm:px-3 sm:py-1.5 bg-[#fd3e3d]/10 rounded-full text-[#fd3e3d] font-medium">
                    <Calendar className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                    <span className="text-xs sm:text-sm">{tagline}</span>
                  </div>
                )}

                {features && features.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 sm:gap-2 mt-2 sm:mt-3">
                    {features.map((feature, idx) => (
                      <span
                        key={idx}
                        className="px-2 py-1 sm:px-3 sm:py-1.5 bg-neutral-100 text-neutral-600 text-xs font-medium rounded-lg border border-neutral-200 hover:bg-[#fd3e3d] hover:text-white hover:border-[#fd3e3d] transition-all duration-300 cursor-default flex items-center gap-1.5"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-[#fd3e3d]" />
                        {feature}
                      </span>
                    ))}
                  </div>
                )}

                {/* Stats - smaller */}
                {stats && (
                  <div className="mt-2 sm:mt-3 flex items-center gap-1.5 text-neutral-400">
                    <Users className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                    <span className="text-xs">
                      {stats.value} {stats.label}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* Right section - CTA buttons - stacked on mobile */}
            <div className="flex flex-row sm:flex-col gap-2 shrink-0 sm:self-center">
              {hasSupport && (
                <button className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 bg-neutral-100 text-black rounded-xl hover:bg-black hover:text-white transition-all duration-300 font-medium text-xs sm:text-sm">
                  <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                  <span>Support Call</span>
                </button>
              )}

              <button
                onClick={() => handleRegisterClick(full)}
                className="relative flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-[#fd3e3d] text-white rounded-xl hover:bg-black transition-all duration-300 font-semibold text-xs sm:text-sm overflow-hidden group/btn shadow-lg shadow-[#fd3e3d]/20 hover:shadow-black/20"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700" />
                <span className="relative">Apply Now</span>
                <ArrowRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 relative group-hover/btn:translate-x-0.5 transition-transform" />
              </button>

              
            </div>
          </div>

          {/* Bottom decorative line */}
          <div className="absolute bottom-0 left-1 sm:left-1.5 right-0 h-0.5 bg-neutral-100 overflow-hidden rounded-br-2xl sm:rounded-br-3xl">
            <div className="h-full w-0 group-hover:w-full bg-gradient-to-r from-[#fd3e3d] to-[#ff7b7b] transition-all duration-700 ease-out" />
          </div>
        </div>

        {isModalOpen && (
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-3 sm:p-4"
            onClick={() => setIsModalOpen(false)}
          >
            <div
              className="relative bg-white rounded-2xl sm:rounded-3xl w-full max-w-md overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="relative bg-[#fd3e3d] p-4 sm:p-5 text-white">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white/20 flex items-center justify-center">
                      <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
                    </div>
                    <div>
                      <h3 className="text-base sm:text-lg font-bold">Apply Now</h3>
                      <p className="text-white/80 text-xs sm:text-sm line-clamp-1">{title}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                  >
                    <X className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>
                </div>
              </div>

              {/* Form */}
              <form ref={formRef} onSubmit={handleSubmit} className="p-4 sm:p-5 space-y-3">
                <div className="space-y-4">

                  {/* Add email & phone fields if paid event and not already present */}

                  {selectedEvent.type[0] === "Paid" &&
                    !selectedEvent.fields.some(
                      (f) => f.label.toLowerCase() === "email"
                    ) && (
                      <div className="mb-3">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name *"
                          required
                          value={form.name || ""}
                          onChange={(e) => setForm({ ...form, name: e.target.value })}
                          className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        />
                        {errors.email && (
                          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                        )}
                      </div>
                    )}
                  {selectedEvent.type[0] === "Paid" &&
                    !selectedEvent.fields.some(
                      (f) => f.label.toLowerCase() === "email"
                    ) && (
                      <div className="mb-3">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email *"
                          required
                          value={form.email || ""}
                          onChange={(e) => setForm({ ...form, email: e.target.value })}
                          className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        />
                        {errors.email && (
                          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                        )}
                      </div>
                    )}

                  {selectedEvent.type[0] === "Paid" &&
                    !selectedEvent.fields.some(
                      (f) => f.label.toLowerCase() === "phone"
                    ) && (
                      <div className="mb-3">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone *"
                          required
                          value={form.phone || ""}
                          onChange={(e) => setForm({ ...form, phone: e.target.value })}
                          className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        />
                        {errors.phone && (
                          <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                        )}
                      </div>
                    )}

                  {selectedEvent?.fields?.length > 0 &&
                    selectedEvent.fields.map((each) => {
                      const fieldName = each.label.toLowerCase().replace(/\s+/g, "_");

                      // Determine if this field should be required due to paid event
                      const isPaidRequired =
                        selectedEvent.type === "paid" &&
                        (fieldName === "email" || fieldName === "phone");

                      return (
                        <div key={fieldName} className="mb-3">
                          <input
                            type={each.value}
                            name={fieldName}
                            placeholder={each.label}
                            required={each.required || isPaidRequired}
                            value={form[fieldName] || ""}
                            onChange={(e) =>
                              setForm({ ...form, [fieldName]: e.target.value })
                            }
                            className={`w-full p-3 border ${errors[fieldName] ? "border-red-500" : "border-gray-200"
                              } rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400`}
                          />
                          {errors[fieldName] && (
                            <p className="text-red-500 text-xs mt-1">{errors[fieldName]}</p>
                          )}
                        </div>
                      );
                    })}



                </div>

                {selectedEvent.type?.[0]?.toLowerCase() === "paid" && (
                  <p className="text-sm text-gray-500 text-center">
                    You'll be redirected to a secure payment page to complete your registration.
                  </p>
                )}
                <button
                  type="button"
                  onClick={handlePayButtonClick}
                  disabled={processing || payLoading}
                  className="w-full py-2 bg-gradient-to-r from-red-500 to-pink-500 text-white font-medium rounded-lg hover:opacity-90 transition disabled:opacity-70 flex items-center justify-center"
                >
                  {processing ? (
                    <ClipLoader color="#ffffff" size={20} className="mr-2" />
                  ) : selectedEvent.type[0].toLowerCase() === "paid" ? (
                    processing ? (
                      "Loading..."
                    ) : (
                      `Pay ₹${selectedEvent.amount}`
                    )
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        )}
      </>
    )
  }
// exclusive event
  export function ExclusiveEvents() {
      const [AllEvents,setAllEvents]=useState([])
      const [eventLoader,setEventLoader]=useState(false)
    const colorPalette = [
    {
      primary: "#FF7A5C", // softer orange-red (lighter than #FF6B3D)
      gradient: "from-[#FF7A5C] to-[#FF9B80]",
    },
    {
      primary: "#6AA6FF", // lighter, softer blue
      gradient: "from-[#6AA6FF] to-[#9BC4FF]",
    },
    {
      primary: "#B58AD6", // soft pastel purple
      gradient: "from-[#B58AD6] to-[#D7B9ED]",
    },
    {
      primary: "#FF9F50", // warm light orange (replaces green)
      gradient: "from-[#FF9F50] to-[#FFC18A]",
    },
    {
      primary: "#FFB07C", // light peach-orange
      gradient: "from-[#FFB07C] to-[#FFD1B2]",
    },
  ];

    const events = [
      {
        icon: Flame,
        title: "Tactos Roast Events",
        subtitle: "Get your startup roasted by industry experts in an exclusive setting",
        stats: { value: "500+", label: "Startups Roasted" },
      },
      {
        icon: Building2,
        title: "Residency Program",
        features: ["Access for your Capital", "Mentor Network", "Co-working Space"],
      //   hasSupport: true,
        stats: { value: "50+", label: "Residents" },
      },
      {
        icon: GraduationCap,
        title: "Catalytic Boot Camps / Cohorts",
        features: ["Investor Connect", "Demo Day", "Pitch Training"],
      //   hasSupport: true,
        stats: { value: "200+", label: "Graduates" },
      },
      {
        icon: TrendingUp,
        title: "Tactos Fundraising Events",
        tagline: "Tactos Raise the Stage. You Raise Your Funds.",
        stats: { value: "₹10Cr+", label: "Raised" },
      },
    ]

    const getEventDateTime = (event) => {
      try {
        const timePart = event.time ? event.time : "00:00";
        return new Date(`${event.date}T${timePart}:00`);
      } catch (e) {
        return new Date(event.date || 0);
      }
    };

    // Helper: compute a client-side status for an event based on datetime
    const computeStatusForEvent = (event) => {
      const eventDT = getEventDateTime(event);
      if (isNaN(eventDT.getTime())) return event.status || "Upcoming";
      return eventDT.getTime() < Date.now() ? "Completed" : (event.status || "Upcoming");
    };

    // Helper: normalize an array of events so UI uses computed status
    const normalizeEvents = (events) => {
      return events.map(e => {
        const computedStatus = computeStatusForEvent(e);
        return { ...e, status: computedStatus };
      });
    };

    useEffect(() => {
    const fetchEvents = async () => {
      try {
        setEventLoader(true)
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/events`
        );

        let events = normalizeEvents(
          Array.isArray(res.data) ? res.data : res.data?.data || []
        );

        console.log("All normalized events:", events);

        const token = localStorage.getItem("Startuptoken");

        if (token && token !== "DEMO_TOKEN") {
          // ✅ Logged in → Registered + Exclusive
          events = events.filter(
            (event) =>
              (event.eventMode?.includes("Registered") ||
                !event.eventMode) &&
              event.isExclusiveEvent === true
          );
        } else {
          // ✅ Guest → NonRegistered + Exclusive
          events = events.filter(
            (event) =>
              (event.eventMode?.includes("NonRegistered") ||
                !event.eventMode) &&
              event.isExclusiveEvent === true
          );
        }

        console.log("Filtered events:", events);
        setAllEvents(events);
      } catch (error) {
        console.error("Failed to fetch events", error);
      }finally{
        setEventLoader(false)
      }
    };

    fetchEvents();
  }, []);

  useEffect(()=>{
    console.log(AllEvents)
  },[AllEvents])

    return (
      <section className="w-full max-w-5xl mx-auto px-3 sm:px-4 py-8 sm:py-12">
   {eventLoader ? (
  <ExclusiveEventsSectionSkeleton />
) : (
  <>
    {/* Header */}
   {AllEvents.length<=0?"": <><div className="mb-8 sm:mb-12 text-center">
      <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#fd3e3d]/10 text-[#fd3e3d] text-xs font-semibold mb-4">
        <Calendar className="w-3 h-3" />
        Exclusive Programs
      </div>

      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black mb-2 sm:mb-3">
        Join Our <span className="text-[#fd3e3d]">Exclusive Events</span>
      </h2>

      <p className="text-neutral-500 max-w-xl mx-auto text-sm sm:text-base">
        Accelerate your startup journey with curated programs designed for ambitious founders
      </p>
    </div>

    
    <div className="flex flex-col gap-4 sm:gap-5">
      {AllEvents.map((event, index) => (
        <EventCard
          key={event.id || index}
          index={index}
          title={event.name}
          subtitle={event.title}
          tagline={event.date}
          logo={event.logo}
          full={event}
        />
      ))}
    </div></>}
      
  </>
)}

      

      
      </section>
    )
  }

  export default ExclusiveEvents


  const ExclusiveEventsSectionSkeleton = () => {
  return (
    <div className="w-full animate-pulse">
      
      {/* Header skeleton */}
      <div className="mb-8 sm:mb-12 text-center">
        {/* Badge */}
        <div className="mx-auto mb-4 h-6 w-40 rounded-full bg-gray-200" />

        {/* Title */}
        <div className="mx-auto mb-3 h-8 sm:h-10 w-72 sm:w-96 rounded bg-gray-200" />

        {/* Description */}
        <div className="mx-auto h-4 w-80 sm:w-[420px] rounded bg-gray-200" />
      </div>

      {/* Event cards skeleton */}
      <div className="flex flex-col gap-4 sm:gap-5">
        {Array.from({ length: 3 }).map((_, index) => (
          <EventCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

  const EventCardSkeleton = () => {
  return (
    <div className="group relative w-full min-h-[180px] md:max-h-[145px] overflow-hidden rounded-2xl sm:rounded-3xl bg-white border border-neutral-200 animate-pulse">
      
      {/* Left accent stripe */}
      <div className="absolute left-0 top-0 bottom-0 w-1 sm:w-1.5 bg-gray-200 rounded-l-2xl sm:rounded-l-3xl" />

      <div className="relative h-full p-4 sm:p-6 md:p-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        
        {/* Icon skeleton */}
        <div className="w-12 h-12 rounded-xl bg-gray-200 shrink-0" />

        {/* Content skeleton */}
        <div className="flex-1 space-y-3">
          <div className="h-4 w-1/3 bg-gray-200 rounded" />
          <div className="h-3 w-2/3 bg-gray-200 rounded" />
          <div className="h-3 w-1/4 bg-gray-200 rounded" />
        </div>

        {/* Button skeleton */}
        <div className="w-28 h-10 bg-gray-200 rounded-xl" />
      </div>
    </div>
  );
};
